interface CardProps {
  readonly children: React.ReactNode;
  readonly highlighted?: boolean;
}

export const Card = ({ children, highlighted }: CardProps) => (
  <div
    style={{
      backgroundColor: 'var(--bg-surface)',
      border: highlighted
        ? '1px solid var(--text-accent)'
        : '0.5px solid var(--border-default)',
      borderRadius: 'var(--radius-lg)',
      padding: '14px 18px',
      marginBottom: '12px',
      transition: 'border-color 200ms',
    }}
  >
    {children}
  </div>
);
